import request from "@/utils/http"

export function previewChartData(chart, drillDownId, dashboardId) {
  return request
    .post("/bi/previewChartData", chart, { params: { drillDownId, dashboardId } })
    .commonDeal()
}

export function getChartData(
  chartId,
  dashboardId,
  drillDownId,
  filters,
  resFilters,
  dataId = null
) {
  return request
    .post("/bi/getChartData", { chartId, dashboardId, drillDownId, filters, resFilters, dataId })
    .commonDeal()
}

// 指标
export function addExtraField(sheetId, extraField) {
  return request.post("/bi/addExtraField", extraField, { params: { sheetId } }).commonDeal()
}

export function updateExtraField(sheetId, extraField) {
  return request.post("/bi/updateExtraField", extraField, { params: { sheetId } }).commonDeal()
}

export function getExtraFields(sheetId) {
  return request.get(`/bi/getExtraFields`, { params: { sheetId } }).commonDeal()
}

export function deleteExtraField(fieldId, sheetId) {
  return request.post(`/bi/deleteExtraField`, null, { params: { fieldId, sheetId } }).commonDeal()
}

export function getGeoJson(code) {
  return request.get(`/bi/getGeoJson`, { params: { code } })
}

export function getDistinctTextValueList(searchData) {
  return request.post(`/bi/getDistinctTextValueList`, searchData).commonDeal()
}

export function sortDataTitle(dataTitles) {
  return request.post(`/sheet/sortDataTitle`, dataTitles).commonDeal()
}
